import { themeOptionFactories } from "extensions/em-core/theme"

export const emCore = {
  themeOptionFactories,
}
